import React from "react";
import { Image } from "react-bootstrap";
import generique from "../../../assets/images/tools/icon_generique.png";
import onenote from "../../../assets/images/tools/icon_onenote.png";
import sharepoint from "../../../assets/images/tools/icon_sharepoint.png";
import powerbi from "../../../assets/images/tools/icon_powerbi.png";
import pdf from "../../../assets/images/tools/icon_pdf.png";
import colidee from "../../../assets/images/tools/icon_colidee.png";
import missions from "../../../assets/images/tools/icon_missions.png";
import teams from "../../../assets/images/tools/icon_teams.png";
import excel from "../../../assets/images/tools/icon_excel.png";
import word from "../../../assets/images/tools/icon_word.png";
import powerpoint from "../../../assets/images/tools/icon_powerpoint.png";

const ComponentLien = (props) => {
  const { icone, url, nom } = props;

  const switchIcon = () => {
    switch (icone) {
      case "onenote":
        return onenote;

      case "sharepoint":
        return sharepoint;

      case "powerbi":
        return powerbi;

      case "pdf":
        return pdf;

      case "colidee":
        return false;

      case "missions":
        return missions;

      case "teams":
        return teams;

      case "excel":
        return excel;

      case "word":
        return word;

      case "powerpoint":
        return powerpoint;

      default:
        return generique;
    }
  };

  return (
    <>
      {icone !== "colidee" && (
        <a href={url} target="_blank" rel="noreferrer">
          <Image src={switchIcon()} className="m-2" />
          {nom ? nom : url.length > 40 ? url.slice(0, 40) + " ..." : url}
        </a>
      )}
    </>
  );
};

export default ComponentLien;
